import { _setupFunctions } from './setupFunctions';
import functionsSchemas from './schemas';
import { cloneDeep } from 'lodash-es';
import { _setupEvents } from './setupEvents';
import MetafieldValuesService from '../../service/metafieldValuesService';
import CartAppExtensionService from '../../service/cartAppExtensionService';

const externalServices = {};
let utilsFunctions = {};
let knownSdkEventNames = [];

function _groupDependencies(functionsSchema) {
  return functionsSchema.reduce(
    (acc, funcSchema) => {
      switch (funcSchema.type) {
        case 'angularData':
        case 'angularFunc': {
          const source = funcSchema.options?.source;
          if (source && !acc.angular.includes(source)) {
            acc.angular.push(source);
          }
          break;
        }
        case 'nativeFunc': {
          const source = funcSchema.options?.source;
          if (source && !acc.native.includes(source)) {
            acc.native.push(source);
          }
          break;
        }

        default:
          break;
      }

      return acc;
    },
    { angular: [], native: [] },
  );
}

function _getCurrentPageFunctionsSchemas(currentPage) {
  const globalSchema = cloneDeep(functionsSchemas.all);
  const pageSchema = cloneDeep(functionsSchemas[currentPage]);

  const allFunctions = [
    ...(globalSchema?.functions || []),
    ...(pageSchema?.functions || []),
  ];
  const allEvents = [
    ...(globalSchema?.events || []),
    ...(pageSchema?.events || []),
  ];

  const allDeps = _groupDependencies(allFunctions);

  return {
    dependencies: allDeps,
    functions: allFunctions,
    events: allEvents,
  };
}

function _getAngularService(angularInjector, serviceName) {
  if (!externalServices[serviceName]) {
    externalServices[serviceName] = angularInjector.get(serviceName);
  }

  return externalServices[serviceName];
}

// Load angular dependencies for functions
function _loadAngularDependencies(angularInjector, dependencies) {
  const angularDeps = dependencies?.angular || [];

  return angularDeps.reduce((acc, currDep) => {
    acc[currDep] = _getAngularService(angularInjector, currDep);
    return acc;
  }, {});
}

// Load native js dependencies for functions.
const _loadNativeDependencies = (dependencies) => {
  const deps = {};
  for (const dep of dependencies.native) {
    switch (dep) {
      case 'MetafieldValuesService':
        deps[dep] = MetafieldValuesService;
        break;
      case 'CartAppExtensionService':
        deps[dep] = CartAppExtensionService;
        break;
    }
  }
  return deps;
};

function _loadDependencies(angularInjector, dependencies) {
  return {
    angular: _loadAngularDependencies(angularInjector, dependencies),
    native: _loadNativeDependencies(dependencies),
  };
}

function _initializeUtils(currentPage) {
  const currentSchema = _getCurrentPageFunctionsSchemas(currentPage);

  const angularInjector = angular.element('html').injector();

  const dependencies = _loadDependencies(
    angularInjector,
    currentSchema.dependencies,
  );
  utilsFunctions = _setupFunctions(dependencies, currentSchema.functions);
  _setupEvents(currentSchema.events);

  knownSdkEventNames = currentSchema.events.map(
    (e) => e.sdkEvent ?? e.incomingEvent,
  );
}

export { utilsFunctions, knownSdkEventNames, _initializeUtils };
